import styled, { css } from 'styled-components';
import { COLOR_DARK_PURPLE, COLOR_WHITE } from '../../../../assets/styles/colors';

export const OptionsSwitcherSC = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
`;

export const ButtonSC = styled.button`
  background-color: ${COLOR_DARK_PURPLE};
  color: ${COLOR_WHITE};
  border-color: transparent;
  font-weight: bold;
  font-size: 18px;
  border-radius: 8px;
  padding: 4px 8px;
  margin: 4px 10px;
  flex: 1 0 auto;
  min-width: 40px;
  min-height: 40px;

  ${({ isActive }) => {
    if (isActive) {
      return css`
        background-image: linear-gradient(to left, #fab535, #f7931e);
      `;
    }

    return css`
      background-color: ${COLOR_DARK_PURPLE};
    `;
  }}
`;
